import Fb from "../images/fb.svg"
import Twitter from "../images/twitter.svg"
import Instagram from "../images/instagram.svg"
import LinkedIn from "../images/linkedin.svg"
import Behance from "../images/behance.svg"

export const socialMediaData = [
  { url: "https://www.facebook.com/triboxdesign", img: Fb },
  { url: "https://www.twitter.com/triboxdesignph", img: Twitter },
  { url: "https://www.instagram.com/triboxdesign", img: Instagram },
  { url: "https://www.linkedin.com/company/triboxdesign", img: LinkedIn },
  { url: "https://www.behance.net/triboxdesign", img: Behance },
]
